import React, { useEffect, useState } from "react";
import Reveal from "../components/Reveal";
import PageSeo from "../components/PageSeo";
import { fetchExperiences } from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { useSettings } from "../context/SiteSettingsContext";

export default function ExperiencePage() {
  const { t, lang } = useLang();
  const settings = useSettings();
  const [items, setItems] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchExperiences().then(setItems).catch(() => {}); }, []);

  const seoTitle = lang === "en" ? settings.experiences_meta_title_en : settings.experiences_meta_title_it;
  const seoDesc = lang === "en" ? settings.experiences_meta_desc_en : settings.experiences_meta_desc_it;

  return (
    <div className="pt-32 pb-24 lg:pb-40 bg-[#09090b] min-h-screen" data-testid="experience-page">
      <PageSeo title={seoTitle} description={seoDesc} pathIt="/it/esperienza-torino" pathEn="/en/turin-experience" />
      <div className="container-x">
        <Reveal>
          <div className="overline mb-4">{t.turin.overline}</div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1] max-w-3xl">
            {t.turin.title.split("\n").map((l, i) => (<span key={l || `ep-line-${i}`} className="block">{l}</span>))}
          </h1>
          <p className="mt-6 text-white/70 max-w-xl">{t.turin.subtitle}</p>
        </Reveal>

        <div className="mt-20 space-y-24">
          {items.map((exp, i) => {
            const title = lang === "it" ? exp.title_it : exp.title_en;
            const content = lang === "it" ? exp.content_it : exp.content_en;
            const slug = lang === "it" ? exp.slug_it : exp.slug_en;
            const reverse = i % 2 === 1;
            return (
              <Reveal key={exp.id}>
                <div id={slug} className={`grid lg:grid-cols-12 gap-8 lg:gap-16 items-center ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
                  <div className="lg:col-span-6">
                    <div className="aspect-[5/4] overflow-hidden border border-white/10">
                      <img src={exp.cover} alt={title} className="w-full h-full object-cover" />
                    </div>
                  </div>
                  <div className="lg:col-span-6">
                    <div className="overline mb-3">{exp.category}</div>
                    <h2 className="font-serif text-4xl lg:text-5xl leading-tight mb-5">{title}</h2>
                    <p className="text-white/70 text-lg leading-relaxed">{content}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  );
}
